(function () {
    'use strict';

    angular
        .module('app')
        .component('feedRssListAdmin', {
            templateUrl: 'app/components/feedrss/admin/feedrss/feed-rss-list.admin.html',
            controller: Controller,
            controllerAs: 'ctrl'
        });

    /* @ngInject */
    function Controller($stateParams, NG_TABLE_DEFAULT_PARAMS, NgTableParams, NgTableHelper,
                        ModalService, FeedRss) {
        var vm = this;

        vm.item = FeedRss;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.filter = {
            key: undefined
        };
        vm.tableParams = new NgTableParams({
            count: NG_TABLE_DEFAULT_PARAMS.size,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {nombre: 'asc'}
        }, NgTableHelper.settings(vm));

        // Eliminar
        vm.showRemoveConfirmation = function (id) {
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    resolve: {
                        /* @ngInject */
                        item: function (FeedRss) {
                            return FeedRss.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'feedsRss.feedRss.admin.delete.title',
                                body: 'feedsRss.feedRss.admin.delete.confirm',
                                property: 'nombre'
                            };
                        }
                    }
                }
            ).result.then(function () {
                vm.tableParams.reload();
            });
        };
    }

})();
